import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouterV6 as withRouter } from '../../../helpers/withRouterV6.jsx';
import get from 'lodash.get';

import * as templateBuilderActions from '../../../modules/template-builder-ex';
import * as programActions from '../../../pages/vipProgram/store/vipProgramActions';

import TemplateBuilderContainerEx from '../../../components/template/builder/indexEx';

import { getSetupTab } from './templateTabs/setup';
import { getApplicationQuestionsTab } from './templateTabs/applicationQuestions';
import { getEmailsTab } from './templateTabs/emails';
import { getTermsAndConditionsTab } from './templateTabs/termsAndConditions';
import { getAnnouncementsTab } from './templateTabs/announcements';

import { paths } from './constants/template';
import config from '../../../constants';
import { getValue } from '../../../components/template/templateHelper';
import { normaliseCurrency } from '../helpers/currencyTargets';
import { getEntityOption } from '../../../helpers/entityOptionHelper';

class VipProgramTemplateView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddressHidden: false,
      isPhoneHidden: true,
      isCountryAllowed: true,
    };

    this.required = {
      required: true
    };

    this.programNameValidation = {
      required: true,
      maxLength: true,
      length: config.VIP_PRORGAM_PROGRAM_NAME_MAX_LENGTH
    };

    this.participantNameValidation = {
      maxLength: true,
      length: config.VIP_PROGRAM_PARTICIPANT_NAME_MAX_LENGTH
    };

    this.requestValidation = {
      optionalRecord: true
    };

    this.dateValidation = {
      required: true,
      date: true
    };

    this.formBuilderQuestionsValidation = {
      formbuilderQuestionsRequired: true,
      formBuilderQuestions: true
    };

    this.optional = {
      required: false
    };

    this.currencyTargetsValidation = {
      currencyTargets: true
    };

    this.urlValidation = {
      url: true
    };

    this.waiverBuilderValidation = {
      waiverBuilder: true
    };
  }

  onChange = (path, value, _) => {
    this.props.templateBuilderActions.setResultValue(path, value);
  };

  getRecordRequest = (value) => {
    this.props.programActions.getEventAmbassadorProgramRecord(value);
  };

  clearRecord = (record) => {
    this.props.programActions.clearRecord(record);
  };

  getEventRequest = () => {
    return {
      page: 1,
      pageSize: 75,
      resultType: 'Full',
      orderBy: {
        key: 'name',
        direction: 'asc'
      },
      filters: [
        {
          key: 'status',
          operator: 'EqualTo',
          value: 1
        }
      ],
      includeDataTemplate: true
    };
  };

  onEventChange = (path, value, item) => {
    this.props.templateBuilderActions.setResultValue(path, value);

    if (path === paths.EVENT_ID) {
      const currency = item
        ? normaliseCurrency(item.currency || get(item, 'organization.currency'))
        : null;
      this.props.templateBuilderActions.setResultValue(paths.CURRENCY, currency);
    }
  };

  getLockedCurrencies = () => {
    if (!this.props.isEdit) {
      return [];
    }

    return (this.props.savedCurrencyTargets || [])
      .map((target) => normaliseCurrency(target.currency))
      .filter(Boolean);
  };

  getEventItem = (item) => getEntityOption(item);

  onAllowTermsAndConditionsChange = (path, value) => {
    this.props.templateBuilderActions.changeItemVisibility(
      paths.TERMS_AND_CONDITIONS_TITLE,
      value,
      true
    );
    this.props.templateBuilderActions.changeItemVisibility(
      paths.TERMS_AND_CONDITIONS_LINK,
      value,
      true
    );

    this.onChange(path, value);
  };

  onAllowWaiversChange = (path, value) => {
    this.props.templateBuilderActions.changeItemVisibility(
      paths.WAIVERS,
      value,
      true
    );

    this.onChange(path, value);
  };

  render() {
    const setupTab = getSetupTab({
      onChange: this.onChange,
      required: this.required,
      programNameValidation: this.programNameValidation,
      participantNameValidation: this.participantNameValidation,
      getRecordRequest: this.getRecordRequest,
      clearRecord: this.clearRecord,
      getEventRequest: this.getEventRequest,
      onEventChange: this.onEventChange,
      getEventItem: this.getEventItem,
      dateValidation: this.dateValidation,
      optional: this.optional,
      currencyTargetsValidation: this.currencyTargetsValidation,
      lockedCurrencies: this.getLockedCurrencies(),
      requestValidation: this.requestValidation,
      isSystemAdmin: this.props.isSystemAdmin
    });
    const applicationQuestionsTab = getApplicationQuestionsTab({
      onChange: this.onChange,
      required: this.required,
      formBuilderQuestionsValidation: this.formBuilderQuestionsValidation,
      isAddressHidden: this.state.isAddressHidden,
      isPhoneHidden: this.state.isPhoneHidden,
      isCountryAllowed: this.state.isCountryAllowed
    });
    const emailsTab = getEmailsTab({
      onChange: this.onChange,
      optional: this.optional
    });
    const termsAndConditionsTab = getTermsAndConditionsTab({
      onChange: this.onChange,
      required: this.required,
      urlValidation: this.urlValidation,
      waiverBuilderValidation: this.waiverBuilderValidation,
      onAllowTermsAndConditionsChange: this.onAllowTermsAndConditionsChange,
      onAllowWaiversChange: this.onAllowWaiversChange
    });
    const announcementsTab = getAnnouncementsTab({
      onChange: this.onChange,
      announcementEnabled: this.props.announcementEnabled
    });

    // The announcement is a system admin tool for programs already running, so
    // it stays off the create flow and out of the charity admin's view.
    const showAnnouncementsTab = this.props.isSystemAdmin && this.props.isEdit;

    return (
      <TemplateBuilderContainerEx
        onSave={this.props.onSave}
        showCancelButton
        onCancel={this.props.onCancel}
        isLoading={this.props.isLoading}
      >
        {setupTab}
        {applicationQuestionsTab}
        {emailsTab}
        {termsAndConditionsTab}
        {showAnnouncementsTab && announcementsTab}
      </TemplateBuilderContainerEx>
    );
  }
}

const mapState = (state) => {
  return {
    applicationsOpenDate: getValue(state.templateBuilderEx, "startsAt"),
    isSystemAdmin: get(state, 'session.isSystemAdmin'),
    isEdit: get(state, 'templateBuilderEx.isEdit', false),
    announcementEnabled:
      getValue(state.templateBuilderEx, paths.ANNOUNCEMENT_ENABLED) === true,
    savedCurrencyTargets: get(
      state,
      'program.eventAmbassadorProgramRecord.data.data.currencyTargets'
    ),
  };
};

const mapDispatch = (dispatch) => {
  return {
    templateBuilderActions: bindActionCreators(
      templateBuilderActions,
      dispatch
    ),
    programActions: bindActionCreators(programActions, dispatch)
  };
};

const VipProgramTemplate = withRouter(
  connect(mapState, mapDispatch)(VipProgramTemplateView)
);
export default VipProgramTemplate;
